// @flow
import { take, put, call, fork, cancel } from 'redux-saga/effects';
import { receiveAuth, logout } from 'ducks/authActions';
import { enterRoute, exitRoute } from 'ducks/routeActions';
import appConfigSaga from 'ducks/appConfigSaga';
import { signalAppReady, signalAppNotReady } from 'ducks/appConfigActions';
import authSaga from 'ducks/authSaga';
import coreDataSaga from 'ducks/coreDataSaga';

const matchSuccessfulLogin = action =>
  action.type === receiveAuth.toString() && Boolean(action.error) === false;

function* routeListener() {
  let task;

  while (true) {
    const { payload: { saga, sagaArgs = [], cb } } = yield take(enterRoute);

    if (saga) {
      task = yield fork(saga, ...sagaArgs);
      if (cb) {
        yield call(cb);
      }
      yield take(exitRoute);
      yield cancel(task);
    }
  }
}

function* startUpData() {
  yield fork(appConfigSaga);
}

// start Saga will toggle
function* appSaga() {
  while (true) {
    yield take(matchSuccessfulLogin);

    const startUpTask = yield fork(startUpData);
    const routeListenerTask = yield fork(routeListener);

    yield put(signalAppReady());
    yield take(logout); // add some error conditions
    yield put(signalAppNotReady());
    yield cancel(startUpTask, routeListenerTask);
  }
}

export default function* main(): Generator<*, *, *> {
  yield fork(authSaga);
  yield fork(appSaga);
  yield fork(coreDataSaga);
}



// WEBPACK FOOTER //
// ./src/saga.js